// src/js/modules/appio-reviews.js
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const reviewBox = document.querySelector(".appio-reviews-box");
    if (reviewBox && reviewBox.innerHTML.trim() === "") {
      const closestBlock = reviewBox.closest(".appio-reviews-widget");
      if (closestBlock) {
        closestBlock.style.display = "none";
      }
    }
  }, 1e3);
});
